/**
 * Service index file - centralizes all service exports
 */

// Import new v2 services
import SyncAPI from "./v2/SyncAPI";
import SyncManager from "./v2/SyncManager";

// Export new services as primary
export const syncApi = SyncAPI;

// Re-export other services that might be imported from here in the future
export {
  SyncManager,
  SyncAPI
};